export enum FeatureFlag {
    OGA_FULLSTORY = 'oga-fullstory',
    GIVING_REMEMBERLASTLOGIN_OGA = 'giving_rememberlastlogin_oga',
    OGA_INFORMATION_BANNER = 'oga-information-banner',
    OGA_APPGIFTAMOUNTBANNER_SIGNEDOUT_V2 = 'oga-appgiftamountbanner-signedout-v2',
    HIDE_GIVING_HISTORY = 'hide-giving-history',
    OGA_DEACTIVATE_UNREGISTERED_GPS = 'oga-deactivate-unregistered-gps',
    GIVING_OGA_DDL_AUTOLOGIN_AND = 'giving_oga_ddl_autologin_and',
    OGA_DISABLE_DINERS_CLUB = 'oga-disable-diners-club',
    GIVING_OGA_DDL_AUTOLOGIN_IOS = 'giving_oga_ddl_autologin_ios',
    OGA_CLEVERTAP = 'oga-clevertap',
    OGA_APPFOOTERDEEPLINKS = 'oga-appfooterdeeplinks',
    OGA_APPHISTORY = 'oga-apphistory',
}
